var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 17" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M9.5 2.2L8.4.4H3.6l-1 1.8H.1v2h11.8v-2H9.5zm-5.7-.1l.4-.7h3.6l.4.7H3.8zM.1 16.6h11.8v-11H.1v11zm9.4-8.4h1v6h-1v-6zm-2 0h1v6h-1v-6zm-2 0h1v6h-1v-6zm-2 0h1v6h-1v-6zm-2 0h1v6h-1v-6z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Delete.svg